<script setup lang="ts">

import { twMerge } from 'tailwind-merge'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import FingerDownImage from '@/assets/images/gifs/finger-down.gif'
import FingerUpImage from '@/assets/images/gifs/finger-up.gif'
import { useScreenSize } from '@/composables/helpers/screen-size'

const props = withDefaults(defineProps<{
  wrapperClass?: string
  showDown? :boolean,
  triggerPosition?: number
}>(), {
  wrapperClass: '',
  showDown: true,
  triggerPosition: undefined,
})

const { height } = useScreenSize()
const scrollContainer = ref<HTMLElement | null>(null)
const isLoaded = ref(false)
const totalHeight = ref(0)
const currentPosition = ref(0)
const showFingerDown = computed(() => props.showDown ? currentPosition.value <= totalHeight.value / 2 : false)
const showFinger = computed(() => props.triggerPosition ?  props.triggerPosition < currentPosition.value : true)
function calculateTotalHeight() {
  const mustScrollContainer = scrollContainer.value as HTMLElement
  totalHeight.value = mustScrollContainer.scrollHeight - mustScrollContainer.clientHeight
}

function calculateScrollPosition() {
  currentPosition.value = (scrollContainer.value as HTMLElement).scrollTop
}

function scrollPage() {
  if (!scrollContainer.value) return
  scrollContainer.value.scrollTo({
    top: showFingerDown.value ? scrollContainer.value.scrollHeight : 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  setTimeout(() => {
    scrollContainer.value = document.querySelector('.scroll-container')
    if (!scrollContainer.value) return
    calculateTotalHeight()
    scrollContainer.value.addEventListener('scroll', calculateScrollPosition)
    isLoaded.value = true
  }, 500)
})

onBeforeUnmount(() => {
  if (!scrollContainer.value) return
  scrollContainer.value.removeEventListener('scroll', calculateScrollPosition)
})

watch(height, () => {
  if (!scrollContainer.value) {
    scrollContainer.value = document.querySelector('.scroll-container')
  }
  if (!scrollContainer.value) return
  calculateTotalHeight()
})
</script>

<template>
  <Transition name="fade">
    <div
      v-if="isLoaded && showFinger"
      :class="twMerge('size-[60px] sticky self-end bottom-[140px] -mt-[60px] backdrop-blur-[4px] rounded-full z-[60]', wrapperClass)"
      @click="scrollPage"
    >
      <div class="rounded-full absolute inset-0 backdrop-blur-[4px]  blur-[6px] bg-white/[.44]" />
      <img
        class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 size-9 min-w-[36px] object-cover"
        :src="showFingerDown ? FingerDownImage : FingerUpImage"
      >
    </div>
  </Transition>
</template>

<style scoped>

</style>